import { render, staticRenderFns } from "./allEmergencyEventBtn.vue?vue&type=template&id=9afb94cc"
import script from "./allEmergencyEventBtn.vue?vue&type=script&lang=js"
export * from "./allEmergencyEventBtn.vue?vue&type=script&lang=js"
import style0 from "./allEmergencyEventBtn.vue?vue&type=style&index=0&id=9afb94cc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports